<template>
    <div class="section">                     
        <form class="form-label form-css-label">
            <fieldset>
                <input id="username" name="username" v-model="inputtext" type="text" autocomplete="off" required />
                <label for="username">{{ inputplace }}</label>
            </fieldset>
        </form>               
    </div>
</template>

<script>
    export default {
        name: '',
        props: ['dataplace'],
        data: () => {
            return {
                inputplace: '',
                inputtext: ''
            }
        },
        watch: {
          inputtext: function () {
            this.changeText(this.inputtext)
          }
        },
        mounted() {
            this.getData()
        },
        methods: {
          changeText: function (value){
            this.$emit("atencion", value);
          },
          getData: function () {
              this.inputplace = this.dataplace
          }
        }  
    }
</script>

<style>
fieldset {
    margin: 0;
    padding: 0;
    border: 0;
  }

  input {
    display: block;
    height: 12px;
    padding: 16px 8px;
    border: 0;
    border-radius: 0;
    font-size: 16px;
    line-height: 1;
    background: #fff;
    color: #212121;
    outline: 0;
    border:0px;
    border-bottom:2px solid #ccc;
    -webkit-appearance: none;
       -moz-appearance: none;
            appearance: none;
    transition: all 0.2s ease-in-out;
  }
  .form-label fieldset {
    position: relative;
  }
  .form-label label {
    position: absolute;
    top: 15px;
    left: 8px;
    color: #909090;
    -webkit-transform: translate3d(0, 0, 0);
            transform: translate3d(0, 0, 0);
    transition: all 0.2s ease-in-out;
  }
  
  .form-css-label input[data-empty="false"], .form-css-label input:valid, .form-css-label input:focus {
    padding: 32px 8px 10px;
  }
  .form-css-label input[data-empty="false"] + label, .form-css-label input:valid + label, .form-css-label input:focus + label {
    color: rgb(31, 152, 223);
    font-weight: 700;
    font-size: 12px;
    -webkit-transform: translate3d(0, -10px, 0);
            transform: translate3d(0, -10px, 0);
  }
</style>